var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z","fill":"#1D2939"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }